import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCTuyencodinhtable = React.memo(function BCTuyencodinhtable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số tuyến tham gia khai thác</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sotuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sotuyen_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{data.p1_sotuyen_lientinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p1_tong_sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p1_sophuongtien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>
            {data.p1_sophuongtien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {data.p1_tong_sochuyenxethuchien}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến nội tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {data.p1_sochuyenxethuchien_noitinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{data.p1_tylethuchien_noitinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Tuyến liên tỉnh</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>
            {data.p1_sochuyenxethuchien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>
            {data.p1_tylethuchien_lientinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Doanh thu</td>
          <td className={classes.tablebc_td}>Tr.đ</td>
          <td className={classes.tablebc_td}>{data.p1_doanhthu}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCTuyencodinhtable.propTypes = {
  data: PropTypes.object,
};
export default BCTuyencodinhtable;
